import axios from 'axios';

const { apiHost = '' } = window.ainextConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
